import { apiClient } from './api-client';
import { ApiResponse, Subject, ListSubjectsResponse } from '../types';

export const SubjectService = {
  /**
   * Get subjects by grade ID
   * @param gradeId The ID of the grade to get subjects for
   * @returns Promise that resolves to an array of Subject objects
   */
  async getSubjectsByGradeId(gradeId: number): Promise<Subject[]> {
    const response = await apiClient.get<ApiResponse<ListSubjectsResponse>>(
      `/subjects/grade/${gradeId}`
    );
    return response.data.data.subjects;
  },
  
  /**
   * Get a subject by ID
   * @param id The ID of the subject to retrieve
   * @returns Promise that resolves to a Subject object
   */
  async getSubjectById(id: number): Promise<Subject> {
    const response = await apiClient.get<ApiResponse<Subject>>(`/subjects/${id}`);
    return response.data.data;
  },
  
  /**
   * Create a new subject
   * @param subjectData The subject data to create
   * @returns Promise that resolves to the created Subject object
   */
  async createSubject(subjectData: { name: string, grade_id: number }): Promise<Subject> {
    const response = await apiClient.post<ApiResponse<Subject>>('/subjects', subjectData);
    return response.data.data;
  },

  /**
   * Update an existing subject
   * @param id The ID of the subject to update
   * @param subjectData The subject data to update
   * @returns Promise that resolves to the updated Subject object
   */
  async updateSubject(id: number, subjectData: { name?: string, grade_id?: number }): Promise<Subject> {
    const response = await apiClient.put<ApiResponse<Subject>>(`/subjects/${id}`, subjectData);
    return response.data.data;
  },

  /**
   * Delete a subject
   * @param id The ID of the subject to delete
   * @returns Promise that resolves when the subject is deleted
   */
  async deleteSubject(id: number): Promise<void> {
    await apiClient.delete<ApiResponse<void>>(`/subjects/${id}`);
  }
};